"use strict";

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FieldUtils = _interopRequireDefault(require("../utils/FieldUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotMoreThan = function isNotMoreThan(message, options, fieldID) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;

    var value = _FieldUtils.default.getNumberFromField(field.value);

    var isValid;

    if (fieldID) {
      var fieldValue = _FieldUtils.default.getNumberFromField(form.$(fieldID).value);

      isValid = fieldValue ? value <= fieldValue : true;
    } else {
      isValid = value <= options.max;
      message = message.replace('{max}', options.max);
    }

    return [isValid, message];
  };
};

var _default = isNotMoreThan;
exports.default = _default;
//# sourceMappingURL=isNotMoreThan.js.map